import { Dialog } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "SpotlightDialog";

export const classes = {
  root: `${PREFIX}-root`,
  confirmActions: `${PREFIX}-confirmActions`,
};

export const SpotlightDialog = styled(Dialog)(({ theme }) => ({
  [`&.${classes.root}`]: {
    "& .MuiPaper-root": {
      width: "480px",
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      [`& .${classes.confirmActions}`]: {
        padding: theme.spacing(3),
        paddingTop: 0,
      },
    },
  },
}));
